import { render } from "@/share/components/controls/pagination/Pagination.html?vue&type=template&id=a53eb0bc&scoped=true&external"
import script from "@/share/components/controls/pagination/Pagination.js?vue&type=script&lang=js&external"
export * from "@/share/components/controls/pagination/Pagination.js?vue&type=script&lang=js&external"

import "@/share/components/controls/pagination/Pagination.scss?vue&type=style&index=0&id=a53eb0bc&lang=scss&scoped=true&external"

import exportComponent from "../../../../execute/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a53eb0bc"]])

export default __exports__